<template>
  <div class="layout">
    <div class="siderbar-wrapper" :style="{ width: this.isCollapsed ? '64px' : '180px' }">
      <div class="logo-wrapper">
        <img v-if="!isCollapsed" src="../../assets/logo.png" />
        <img style="width: 55px; height: 55px" v-if="isCollapsed" src="../../assets/logo1.png" />
      </div>
      <el-menu background-color="#2D7DDF" text-color="#fff" active-text-color="#fff" class="menu-wrapper" @open="test"
        router unique-opened :collapse="isCollapsed" 
        :default-active="$route.jumpUrl">
        <template v-for="(item, index) in sider_menu_data">
          <el-menu-item class="menu-item menu-itemFix" v-if="!item.children" :index="item.jumpUrl" :key="index">
            <p class="elStyle">
              <!-- <i :class="item.iconUrl"></i> -->
              <el-image :src="require('../../assets/menu/' + item.iconUrl + '.png')" alt="" class="imgSize"></el-image>
              <span slot="title">{{ item.name }}</span>
            </p>
          </el-menu-item>
          <el-submenu v-else :index="item.jumpUrl">
            <template slot="title">
              <!-- <i class="submenu" :class="item.iconUrl"></i> -->
              <el-image :src="require('../../assets/menu/' + item.iconUrl + '.png')" alt="" class="imgSize"></el-image>
              <span style="position: relative" class="submenu" slot="title">
                <span>
                  {{ item.name }}
                </span>

                <div v-if="(item.name == '订单管理' &&
                  !item.oneIsClick &&
                  $store.getters.orderCount &&
                  ($store.getters.orderCount.sum ||
                    $store.getters.orderCount.orderTask)) ||
                  (item.name == '网站信息管理' &&
                    !item.oneIsClick &&
                    $store.getters.orderCount &&
                    $store.getters.orderCount.wechatUnassignedNum)
                  " style="
                    border-radius: 50%;
                    width: 6px;
                    height: 6px;
                    background: rgb(245, 108, 108);
                    position: absolute;
                    right: -10px;
                    top: 8px;
                  "></div>
              </span>
            </template>
            <el-menu-item class="menu-item menu-itemFix" v-for="(sub_item, sub_index) in item.children"
              :index="sub_item.jumpUrl" :key="sub_index" @click="test(sub_item, item)">
              <p class="elStyle">
                <span v-if="sub_item.twoIsClick ||
                  ['异常订单', '我的订单', '健驰客户导入'].indexOf(
                    sub_item.name
                  ) == -1
                  " slot="title" style="margin-left: 12px">{{ sub_item.name }}</span>

                <span v-if="!sub_item.twoIsClick &&
                  ['异常订单', '我的订单', '健驰客户导入'].indexOf(
                    sub_item.name
                  ) != -1
                  " slot="title" style="margin-left: 12px">
                  <el-badge v-if="$store.getters.orderCount &&
                    ['异常订单', '我的订单', '健驰客户导入'].indexOf(
                      sub_item.name
                    ) != -1 &&
                    getKeyByValue(sub_item.name)
                    " :value="getKeyByValue(sub_item.name)" style="position: absolute; top: -7px">
                    {{ sub_item.name }}
                  </el-badge>
                  <span v-else>{{ sub_item.name }}</span>
                </span>
              </p>
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </div>
    <div class="topbar-wrapper" :style="{ left: this.isCollapsed ? '64px' : '180px' }">
      <div class="menu-collapse-wrapper float-left" @click="toggleMenu">
        <i class="el-icon-adm-menu" :style="{
          transform: 'rotateZ(' + (this.isCollapsed ? '90' : '0') + 'deg)',
        }"></i>
      </div>
      <div v-if="!titleCopy" class="title float-left">
        {{ levelList[levelList.length - 1].meta.title }}
      </div>
      <div v-else class="title float-left">
        {{ titleCopy }}
      </div>
      <!-- <div><a>帮助</a></div> -->
      <ul class="menu-list float-right">

        <li class="menu-item-title">
          <span v-if="isS">
            <div class="btn">
              <div v-for="(item, index) in btns" :key="index"
                :class="[currentIndex == index ? 'btn_item_active' : 'btn_item']" @click="selectSystem(index)">
                {{ item.name }}
              </div>
            </div>
          </span>
          <iframe id="tianqi" scrolling="no" height="26" style="position: relative; top: 5px;" width="250" frameborder="0"
            allowtransparency="true" src="https://i.tianqi.com/index.php?c=code&a=getcode&id=34&h=25&w=280">
          </iframe>

          <span>
            <el-badge :value="upRead ? upRead.length : 0">
              <i @click="(dialogVisible = true), getReadMessageByType(1)" class="el-icon-message"
                style="font-size: 28px; color: #2d7ddf; cursor: pointer"></i>
            </el-badge>
          </span>
          <span @click="toHelp" style="color: #2d7ddf;cursor: pointer;margin-right:10px"><i class="el-icon-question"
              style="margin-right: 5px;"></i>帮助</span>
          <div @click="toPersonal" style="display: inline-block">
            <span v-if="!is_null(personInfo)">{{
              personInfo.parentOrgName
            }}</span>
            <span v-if="!is_null(personInfo)" style="display: inline-block; margin-left: 10px">
              {{ personInfo.orgName }}</span>
            <img v-if="!is_null(personInfo) && is_null(personInfo.img)" src="./../../assets/title.png" alt="" />
            <img v-if="!is_null(personInfo) &&
              !is_null(personInfo.img) &&
              personInfo.img.indexOf('http') < 0
              " :src="imghttp + personInfo.img" alt="" />
            <img v-if="!is_null(personInfo) &&
              !is_null(personInfo.img) &&
              personInfo.img.indexOf('http') > -1
              " :src="personInfo.img" alt="" />
            <span v-if="!is_null(personInfo)" class="user-name">{{ personInfo.reallyName }}</span>
            <span v-if="!is_null(personInfo)" class="user-name">-{{ personInfo.positionName }}</span>
          </div>
          <!-- 			<i class="icon el-icon-adm-help"></i> -->
        </li>
        <li class="menu-item-title" @click="exit">
          <i class="icon iconfont el-icon-adm-exit"></i>
        </li>
      </ul>
    </div>
    <!-- 导航栏	 -->
    <div class="nav" :style="{ left: this.isCollapsed ? '64px' : '180px' }">
      <i class="el-icon-adm-home iconHome" @click="tohome"></i>
      <tarbar></tarbar>
      <!-- <tabs v-if="!$route.meta.keepAlive"></tabs> -->
    </div>
    <div class="content-wrapper" :class="isSpecialPage" ref="content-wrapper" :style="{ left: this.isCollapsed ? '64px' : '180px' }">
      <div class="content">
        <transition name="slide-fade">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" :key="$route.name"></router-view>
          </keep-alive>
        </transition>
        <transition name="slide-fade">
          <router-view v-if="!$route.meta.keepAlive" :key="$route.name"></router-view>
        </transition>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="50%">
      <div slot="title">
        <span style="margin-right: 40px">异常订单及时消息</span>
        <el-button v-if="activeName == 2" type="primary" size="mini" @click="allRead">非异常订单信息全部已读</el-button>
      </div>
      <div v-loading="orderLoading" element-loading-text="商品SKU更新中">

        <div style="overflow: scroll; height: 400px; border: 1px solid #ebeef5">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="未读消息" name="2">
              <el-table :data="upRead" style="width: 100%">
                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column prop="message" label="消息">
                  <template slot-scope="scope">

                    <div v-if="scope.row.type == 2 && scope.row.messageObj !== null">
                      <p>
                        订单号：{{ scope.row.messageObj.orderNo ? scope.row.messageObj.orderNo : '-' }}，渠道：{{
                          scope.row.messageObj.platform ? scope.row.messageObj.platform : '-' }}
                      </p>
                      <p v-for="(item, index) in scope.row.messageObj.goodsList" :key="index">
                        商品：<span style="color:#4b7902">&nbsp;&nbsp;&nbsp;{{ item.updated == false ? '待更新' : '已更新'
                        }}：</span>{{ item.name ? item.name : '-' }},sku:{{ item.skuno ? item.skuno : '-' }}
                      </p>
                      <p>
                        商品数量：{{ scope.row.totalQuantity ? scope.row.totalQuantity : '-' }}，商品总价：{{ scope.row.totalPrice ?
                          scope.row.totalPrice : '-' }}
                      </p>
                      <p>
                        收货电话：{{ scope.row.messageObj.phone ? scope.row.messageObj.phone : '-' }}收货地址：{{
                          scope.row.messageObj.address ? scope.row.messageObj.address : '-' }}
                      </p>
                      <p>在线支付留言：<span>{{ scope.row.messageObj.remarks ? scope.row.messageObj.remarks : '-' }}</span></p>
                      <p v-if="scope.row.messageObj.notice" style="color:red">{{ scope.row.messageObj.notice }}</p>
                    </div>
                    <div v-else>{{ scope.row.message }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="时间">
                  <template slot-scope="scope">
                    {{ $moment(scope.row.createdTime) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="130">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.messageObj == null" type="primary" size="small"
                      @click="read(scope.row.id)">已读</el-button>
                    <el-button v-if="scope.row.type == 2 && scope.row.messageObj !== null" type="primary" size="small"
                      @click="syncOrder(scope.row)">同步订单</el-button>
                    <p v-if="scope.row.type == 2 && scope.row.messageObj !== null" style="font-size:12px">
                      已更新{{ scope.row.updatedNum }}条，还剩{{ scope.row.notUpdated }}条</p>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="已读消息" name="1">
              <el-table :data="readT" style="width: 100%">
                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column prop="message" label="消息">
                  <template slot-scope="scope">
                    <div v-if="scope.row.type === 2 && scope.row.messageObj !== null">
                      <p>
                        订单号：{{ scope.row.messageObj.orderNo ? scope.row.messageObj.orderNo : '-' }}，渠道：{{
                          scope.row.messageObj.platform ? scope.row.messageObj.platform : '-' }}
                      </p>
                      <p v-for="(item, index) in scope.row.messageObj.goodsList" :key="index">
                        商品：<span style="color:#4b7902">&nbsp;&nbsp;&nbsp;{{ item.updated == false ? '待更新' : '已更新'
                        }}：</span>{{ item.name ? item.name : '-' }},sku:{{ item.skuno ? item.skuno : '-' }}
                      </p>
                      <p>
                        商品数量：{{ scope.row.totalQuantity ? scope.row.totalQuantity : '-' }}，商品总价：{{ scope.row.totalPrice ?
                          scope.row.totalPrice : '-' }}
                      </p>
                      <p>
                        收货电话：{{ scope.row.messageObj.phone ? scope.row.messageObj.phone : '-' }}收货地址：{{
                          scope.row.messageObj.address ? scope.row.messageObj.address : '-' }}
                      </p>
                      <p>在线支付留言：<span>{{ scope.row.messageObj.remarks ? scope.row.messageObj.remarks : '-' }}</span></p>
                      <p v-if="scope.row.messageObj.notice" style="color:red">{{ scope.row.messageObj.notice }}</p>
                    </div>
                    <div v-else>{{ scope.row.message }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="时间">
                  <template slot-scope="scope">
                    {{ $moment(scope.row.createdTime) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.type == 2 && scope.row.messageObj !== null" size="small" type="primary"
                      :disabled="scope.row.updateState == false ? false : true"
                      @click="syncOrder(scope.row)">同步订单</el-button>
                    <span style="font-size:12px">{{ scope.row.updateState == true ? '更新完成' : '' }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { sessionStorage } from '@/assets/js/storage'
import mixinsCommon from '@/mixins/common'
export default {
  mixins: [mixinsCommon],
  name: 'layout',
  data() {
    return {
      currentIndex: 0,
      btns: [
        {
          name: '五域'
        },
        {
          name: '航讯通'
        }
      ],
      activeName: '2',
      upRead: [],
      readT: [],
      dialogVisible: false,
      titleCopy: '',
      imghttp: this.ImgHttps,
      sider_menu_data: sessionStorage.getItem('limit')
        ? sessionStorage.getItem('limit').menuTreeList
        : [],
      isCollapsed: false,
      hasClick:false,
      adminMenuShow: false,
      levelList: null,
      personInfo: sessionStorage.getItem('personInfo'),
      errorCount: 0,
      orderLoading: false,
      isS: false,
    }
  },
  created() {
    console.log(this.ImgHttps)
    this.getReadMessageByType(0)
    this.wsConnection()
    this.checkAuth()
    this.getBreadcrumb()
    if (!this.is_null(sessionStorage.getItem('limit'))) {
      this.sider_menu_data = sessionStorage.getItem('limit').menuTreeList
    }
    /*
    this.axios.get("/order/order/return/taskNumber").then((res) => {
      this.$store.dispatch("addOrderCount", res.data);
    });
   */
    this.sider_menu_data.forEach((res) => {
      res.oneIsClick = false
      if (res.children) {
        res.children.forEach((r) => {
          r.twoIsClick = false
        })
      }
    })
    console.log(sessionStorage.getItem('userInfo'))
    this.isS = sessionStorage.getItem('userInfo').employeeFlag == 1 ? true : false,

      this.addLimit()
  },
  computed: {
    user() {
      return this.$store.state.user_id
    },
    cachedViews() {
      return this.$store.state.cacheView
    },
    key() {
      return this.$route.path
    },
    // 特殊页面content处理
    isSpecialPage() {
      let miniPage = ['saleOrder']
      let currentPage = this.$route.name
      if (miniPage.includes(currentPage)) {
        return 'content-mini-wrapper'
      }
    }
  },
  watch: {
    $route() {
      console.log('>>',this.$route.name)
      if (this.$route.name === 'saleOrder') {
         this.isCollapsed = true
      }else if (!this.hasClick ) {
        this.isCollapsed = false
      }
      const q = this.$route.query
      this.titleCopy = ''
      if (q.jage == 1) {
        this.titleCopy = '申请被退货'
      } else if (q.exType == 1 && q.orderType == 0) {
        this.titleCopy = '拒收详情'
      } else if (q.exType == 1 && q.orderType == 1) {
        this.titleCopy = '被退货详情'
      } else if (q.exType == 0) {
        this.titleCopy = '退货详情'
      }
      this.getBreadcrumb()
    }
  },
  methods: {
    selectSystem(index) {
      console.log(index)
      // this.currentIndex = index
      if (index == 0) {
        let url = process.env.VUE_APP_API_BASE_URL_LINK1 + '/#/center?token='
        let token = sessionStorage.getItem('token')
        window.open(url + token);
      } else {
        let url = process.env.VUE_APP_API_BASE_URL_LINK2 + '/#/center?token='
        let token = sessionStorage.getItem('token')
        window.open(url + token);
      }
    },
    toHelp() {
      window.open("https://docs.qq.com/doc/DVXJ2SGdHZWdtSnBQ")
    },
    // 同步订单
    syncOrder(row) {
      this.orderLoading = true
      const params = {
        id: row.id,
        userId: sessionStorage.getItem('user_id'),
        orderNo: row.messageObj.orderNo,
        platformType: row.messageObj.platformType,
        orderStatus: '1'
      }
      this.$api.orderMessage(params).then((res) => {
        if (res.code == 0) {
          this.orderLoading = false
          this.$message.success('更新完成')
          this.getReadMessageByType()
        } else {
          this.orderLoading = false
        }
      })
        .catch((err) => {
          console.log(err)
          this.orderLoading = false
        })
      // this.axios
      //   .get(
      //     '/order/message/websocket/handle/syncOrder?userId=' +
      //       sessionStorage.getItem('user_id') + '&id=' + row.id + '&orderNo=' + row.messageObj.orderNo + '&platformType=' + row.messageObj.platformType + '&orderStatus=1'
      //   )
      //   .then((res) => {
      //     if (res.code == 0) {
      //       this.orderLoading = false
      //       this.$message.success('更新完成')
      //     }
      //   })
    },
    getKeyByValue(e) {
      if (e == '我的订单') {
        return this.$store.getters.orderCount.orderTask
      } else if (e == '异常订单') {
        return this.$store.getters.orderCount.sum
      } else if (e == '健驰客户导入') {
        return this.$store.getters.orderCount.wechatUnassignedNum
      }
    },
    addLimit() {
      const temp = sessionStorage.getItem('limit')
      temp.menuTreeList = this.sider_menu_data
      sessionStorage.setItem('limit', temp)
    },
    test(e, item) {
      if (e.twoIsClick != undefined) {
        this.$set(
          item.children.find((res) => res.jumpUrl == e.jumpUrl),
          'twoIsClick',
          true
        )
      } else {
        this.$set(
          this.sider_menu_data.find((res) => res.jumpUrl == e),
          'oneIsClick',
          true
        )
      }
      this.addLimit()
    },
    handleClick(e) {
      console.log(e.name)
      if (e.name == 1) {
        this.getReadMessageByType(1)
      }
    },
    getReadMessageByType(e) {
      if (e) {
        this.axios
          .get(
            '/order/message/websocket/handle/readList?userId=' +
            sessionStorage.getItem('user_id')
          )
          .then((res) => {
            console.log(res, 'rersfdfdsf')
            if (res.data) {
              res.data.forEach((item) => {
                item.totalQuantity = 0
                item.totalPrice = 0
                item.updateState = true
                if (item.messageObj && item.messageObj.goodsList) {
                  item.messageObj.goodsList.forEach((itemTwo) => {
                    if (itemTwo.updated == false) {
                      item.updateState = false
                    }
                    item.totalQuantity = item.totalQuantity + itemTwo.quantity
                    item.totalPrice = item.totalPrice + itemTwo.price
                  })
                }
              })
            }

            this.readT = res.data
          })
      } else {
        this.axios
          .get(
            '/order/message/websocket/handle/upReadList?userId=' +
            sessionStorage.getItem('user_id')
          )
          .then((res) => {
            // console.log(res, 'res')
            if (res.data) {
              res.data.forEach((item) => {
                item.totalQuantity = 0
                item.totalPrice = 0
                item.updatedNum = 0
                item.notUpdated = 0
                if (item.messageObj && item.messageObj.goodsList) {
                  item.messageObj.goodsList.forEach((itemTwo) => {
                    if (itemTwo.updated == true) {
                      item.updatedNum = item.updatedNum + 1
                    } else {
                      item.notUpdated = item.notUpdated + 1
                    }
                    item.totalQuantity = item.totalQuantity + itemTwo.quantity
                    item.totalPrice = item.totalPrice + itemTwo.price
                  })
                }
              })
            }

            // res.data.messageObj.goodsList.forEach((item) => {
            //   item.totalQuantity += item.quantity
            //   item.price += item.price
            // })
            this.upRead = res.data
            // console.log(this.upRead, 'this.upRead')
          })
      }
    },
    allRead() {
      this.axios
        .get(
          '/order/message/websocket/handle/oneKeyRead?userId=' +
          sessionStorage.getItem('user_id')
        )
        .then((res) => {
          this.getReadMessageByType(0)
        })
    },
    read(e) {
      this.axios
        .get(
          '/order/message/websocket/handle/read?id=' +
          e +
          '&userId=' +
          sessionStorage.getItem('user_id')
        )
        .then((res) => {
          this.getReadMessageByType(0)
        })
    },
    wsConnection() {
      const baseURL = process.env.VUE_APP_API_BASE_URL
      let wsURL = ''
      if (baseURL.indexOf('http://') > -1) {
        wsURL = baseURL.replace('http://', 'wss://')
      } else {
        wsURL = baseURL.replace('https://', 'wss://')
      }
      console.log(wsURL)
      const userId = sessionStorage.getItem('user_id')
      this.ws = new WebSocket(`${wsURL}/order/websocket/${userId}`)
      this.ws.onopen = () => {
        // console.log("id为" + sessionStorage.getItem("user_id") + "连接成功");
      }
      this.ws.onmessage = (res) => {
        /*
        const temp = JSON.parse(res.data)
        this.$notify({
          title: '自定义位置',
          message: temp.message,
          position: 'bottom-right'
        })
        document
          .getElementsByClassName('el-badge')[0]
          .setAttribute('class', 'el-badge item')
        setTimeout(() => {
          document
            .getElementsByClassName('el-badge')[0]
            .setAttribute('class', 'el-badge')
        }, 1000)
        */
      }
      this.ws.onclose = (res) => {
        // console.log(res);
      }
    },
    tohome() {
      // 区分登陆某个系统显示的首页
      if (sessionStorage.getItem('userInfo').winType != '1') {
        this.$router.push('/dashboard')
      } else {
        if (sessionStorage.getItem('personInfo').orgName != '物流部') {
          this.$router.push('/home/welcome')
        } else {
          this.$router.push('/logisticsIndex')
        }
      }
    },
    getBreadcrumb() {
      const matched = this.$route.matched.filter((item) => item.name)
      // const first = matched[0];
      this.levelList = matched
      // console.log(this.levelList)
      const componentName = matched[matched.length - 1].name
      const detail = this.$route.path

      // 当前路由匹配到name
      const name = matched[matched.length - 1].meta.title
      this.$store.dispatch('commitToolBar', { name, detail, componentName })
    },
    checkAuth() {
      const token = this.$store.state.token || sessionStorage.getItem('token')
      // console.log(token+"-------token--layout")
      if (!token) {
        this.$router.replace('/login')
      } else {
        this.getUser()
      }
    },
    getUser() {
      // console.log('超级管理员');
    },
    is_null(content) {
      if (content) {
        return false
      } else {
        return true
      }
    },
    // handleCommand(command) {
    // 	console.log(command);
    // },
    toggleMenu() {
      this.isCollapsed = !this.isCollapsed
      this.hasClick = !this.hasClick
    },
    exit() {
      this.$confirm('即将退出系统登录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.axios.get('/auth/token/logout').then((res) => {
            if (res.code == 0) {
              this.$store.commit('token', '')
              this.$store.commit('user_id', null)
              sessionStorage.clear()
              this.$router.push({
                name: 'login',
                query: {
                  type: 1
                }
              })
            } else {
              this.$message.error(res.message)
            }
          })
          this.$store.commit('closeTar')
        })
        .catch(() => {
          return false
        })
    },
    toPersonal() {
      this.$router.replace({
        path: '/personalinfo'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/variable";

.btn {
  width: 114px;
  height: 32px;
  background: #F0F3FD;
  border-radius: 16px 16px 16px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-top: 0px;
  margin-right: 20px;

  .btn_item {
    width: 52px;
    height: 28px;
    background: #F0F3FD;
    border-radius: 14px 14px 14px 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #939696;
    line-height: 28px;
    text-align: center;
    padding-right: 7px;
  }

  .btn_item_active {
    width: 52px;
    height: 28px;
    background: #4C81EB;
    border-radius: 14px 14px 14px 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 28px;
    text-align: center;
  }
}

.siderbar-wrapper::-webkit-scrollbar {
  display: none;
}

/* 可以设置不同的进入和离开动画 */
.slide-fade-enter-active {
  transition: all 0.3s linear;
}

.slide-fade-leave-active {
  // transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  transition: all 0s linear;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */
  {
  transform: translateX(-20px);
  opacity: 0;
}

/* 可以设置不同的进入和离开动画 */

/deep/.el-badge__content {
  position: absolute;
  top: 0;
}

/deep/.el-table td,
.el-table th {
  text-align: center;
}

/deep/ .el-table th>.cell {
  text-align: center;
  font-size: 16px;
}

/deep/.el-table__row:hover {
  color: rgb(45, 125, 223);
}

/deep/.el-badge {
  margin-top: 10px;
  margin-right: 20px;
}

/deep/.el-badge__content {
  height: 12px;
  line-height: 12px;
  top: 5px;
}

.siderbar-wrapper {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.siderbar-wrapper {
  overflow: -moz-scrollbars-none;
}

.item {
  animation-name: mymove;
  /*动画的名称*/
  transform-origin: center bottom;
  /*设置动画旋转元素的基点为*/
  cursor: pointer;
}

.item {
  animation-duration: 1s;
  /*动画时间*/
  animation-fill-mode: both;
  /*播放后的状态*/
}

.item {
  animation-duration: 1s;
  /*动画时间*/
}

@keyframes mymove {

  0%,
  100%,
  20%,
  50%,
  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
    transform: translate3d(-20px, 0, 0);
  }
}

.siderbar-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: $siderbarWidth;
  z-index: 999;
  background-color: $siderbarBackgroundColor;
  transition: all 0.3s ease-in-out;
  overflow-y: auto;

  .logo-wrapper {
    padding: 16px 0;
    text-align: center;
    font-size: 24px;
    color: #ffffff;

    img {
      width: 95px;
      height: 77px;
      transition: .3s;
    }
  }

  .menu-wrapper {
    position: absolute;
    top: 120px;
    left: 0;
    width: 100%;
    // height:100%;
    border-right: none;
    transition: all ease-in-out;

    &:not(.el-menu--collapse) {
      scrollbar-width: none;
    }

    &:not(.el-menu--collapse) i {
      color: #ffffff;
    }
    
    .el-submenu__title {
      padding: 0px 15px;
    }

    .el-submenu,
    .el-menu-item {
      width: 100%;
    }
  }
}

.submenu {
  padding: 0 !important;
  padding-left: 12px !important;
}

.el-icon-adm-exit {
  color: #2d7edf !important;
  font-size: 20px !important;
}

.menu-item-title {
  display: inline-block;
  vertical-align: middle;
  margin-right: 12px;

  span {
    display: inline-block;
    vertical-align: middle;
    color: #000;
    font-size: 15px;
  }

  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin: 0 10px;
  }
}

.menu-itemFix {
  padding: 0px !important;
  margin: 15px 0;
  height: 30px !important;
  line-height: 30px !important;

  &:hover {
    background-color: #2d7edf !important;
  }
}

.elStyle {
  height: 30px;
  line-height: 20px !important;
  padding-left: 20px !important;

  // width: 80%;
  // border:1px solid #000;
  .imgSize {
    width: 18px;
    height: 18px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 4px;
  }

  i {
    display: inline-block;
    vertical-align: middle;
  }

  span {
    display: inline-block;
    vertical-align: middle;
    height: 18px;
    line-height: 22px;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.2) !important;
    // color: #2d7edf !important;

    i {
      color: #2d7edf !important;
    }
  }
}

.el-menu-item.is-active {
  .elStyle {
    background-color: rgba(0, 0, 0, 0.2) !important;
    // border-top-right-radius: 25px !important;
    // border-bottom-right-radius: 25px !important;
    // width: 55%;
    // background-color: #fff !important;
    // color: #2d7edf;
    // span {
    // color: #2d7edf !important;
    // }
  }
}

/deep/ .el-submenu__title i {
  color: #fff;
}

/deep/.el-menu-item i {
  color: #fff;
}

.nav {
  position: fixed;
  left: $siderbarWidth;
  right: 0;
  overflow: hidden;
  // width:100%;
  top: 50px;
  height: 33px;
  line-height: 30px;
  padding: 0px;
  background-color: #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease-in-out;
  padding: 0 10px;
  z-index: 12;
  border-top: 1px solid #f8f8f8;

  p {
    display: inline-block;
    font-size: 13px;
    padding: 0px 8px;
    margin-right: 8px;
  }

  .iconHome {
    font-size: 18px;
    position: absolute;
    top: 6px;
    left: 30px;
    color: #137dff;
  }
}

.topbar-wrapper {
  position: fixed;
  left: $siderbarWidth;
  right: 0;
  top: 0;
  height: 50px;
  line-height: 50px;
  padding: 0px;
  background-color: $topbarBackgroundColor;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease-in-out;
  z-index: 12;

  .menu-collapse-wrapper {
    height: 100%;
    width: 38px;
    text-align: center;
    cursor: pointer;

    i {
      transition: all 0.3s ease-in-out;
    }
  }

  .title {
    height: 100%;
    font-weight: bold;
  }

  .menu-list {
    width: 80%;
    // padding-left: 20%;
    left: 20%;
    white-space: nowrap;
    overflow: auto;
    position: absolute;
    text-align: right;

    // width:290px;
    .menu-item {
      position: relative;
      // float: left;
      min-width: 45px;
      text-align: center;

      &:hover {
        cursor: pointer;
        background-color: #fff;
      }

      .icon {
        vertical-align: middle;
        font-size: 24px;
      }

      .text {
        display: inline-block;
        vertical-align: middle;
        margin-left: 4px;
        font-size: 16px;
      }
    }
  }
}

.content-wrapper {
  position: fixed;
  left: $siderbarWidth;
  right: 0;
  top: $topbarHeight;
  bottom: 0;
  padding: 20px;
  overflow: auto;
  transition: all 0.3s ease-in-out;

  .content {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
.content-mini-wrapper{
  padding: 10px 0 0 0;
}

/deep/.el-submenu__icon-arrow {
  margin-top: -4px !important;
}

/deep/.el-image__inner {
  vertical-align: middle;
}

/deep/.siderbar-wrapper .menu-wrapper[data-v-372de25b]:not(.el-menu--collapse) {
  overflow-y: initial;
  overflow-x: initial;
}

// 调整布局 手机
@media screen and (max-width: 1000px) {
  #tianqi {
    display: none;
  }

  .org-name,
  .user-name {
    font-size: 10px !important;
  }

  /deep/ {
    .el-pagination__jump,
    .el-pagination__sizes {
      display: none !important;
    }
  }

}</style>
